var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirewallButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 485 188.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        isolation: isolate;\n        opacity: .6;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.9,25.7c0-5.5,4.5-10,10-10h235.5c2.9,0,11.9-1.3,13.8-3.4l7-8c1.9-2.2,4.7-3.4,7.5-3.4h199.5c5.5,0,10,4.5,10,10v168c0,5.5-4.5,10-10,10H10.9c-5.5,0-10-4.5-10-10V25.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewallButton);
export default __webpack_public_path__ + "static/media/firewall_button.0a8f2f1fa1acb20b6a436525d9168193.svg";
export { ForwardRef as ReactComponent };